export default "__VITE_ASSET__07040cdb__"